import { Component, OnInit, Input } from "@angular/core";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "viewchild",
  templateUrl: "viewchild.component.html",
  styleUrls: ["./viewchild.component.scss"],
})
export class ViewChildComponent implements OnInit {
  @Input() isUserAdmin: boolean;
  model: any = {};
  loading = false;
  messages: any;
  childrenData: any;

  constructor(
    private dataService: DataService,
    private alertService: AlertService
  ) {
    this.dataService.children.subscribe((nextVal) => {
      this.childrenData = nextVal;
    });
  }

  public ngOnInit() {
    this.loadAllData();
  }

  public removeChildFromList(child) {
    if (child && child.childId) {
      this.loading = true;
      this.dataService.removeChildFromList(child.childId).subscribe(
        (data) => {
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          let body = error.json && error.json();
          this.alertService.error(
            body && body.statusText
              ? this.messages[body.statusText]
                ? this.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error
          );
        }
      );
    }
  }

  private loadAllData() {
    this.messages = JSON.parse(localStorage.getItem("messages"));
  }
}



// WEBPACK FOOTER //
// ./src/app/child/viewchild.component.ts